/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import axiosInstance from "api/axiosService";
import { useNavigate, useLocation } from "react-router-dom";
import CCarousel from "Common/CCarousel";
import FadeInSection from "../../../Components/FadeInSection";
import Skeleton from "../../../Components/Skeleton";
import { sanitize, scrollToTop } from "../../../Common/Util";

import { Tabs, ConfigProvider } from "antd";

function Network(props) {
  const { t } = useTranslation();
  const [labelData, setLabelData] = useState([]);
  const [partnerData, setPartnerData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const getYouTubeThumbnail = (url) => {
    const videoId = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/,
    )?.[1];
    return videoId
      ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
      : null;
  };
  const partnerTypes = ["strategic partner", "partner", "brand"];
  const location = useLocation();

  const navigate = useNavigate();
  const [currentActiveTab, setCurrentActiveTab] = useState(
    String(location?.state?.activeTab || "1"),
  );

  const renderLabelSkeleton = () => (
    <div className="tab-wrapper">
      {Array.from({ length: 2 }).map((_, index) => (
        <div key={`label-skeleton-${index}`} className="tab-content mb-0 md:mb-12">
          <Skeleton.Text className="w-1/2 h-8 mx-auto mb-8" />
          <div className="image-wrapper flex-col gap-[50px]">
            <Skeleton className="w-full max-w-[960px] mx-auto h-[280px] md:h-[540px]" />
            <div className="mx-wrapper w-full max-w-[960px] mx-auto">
              <Skeleton text textLines={4} textClassName="h-4" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const renderPartnerSkeleton = () => (
    <div className="tab-wrapper">
      {partnerTypes.map((type) => (
        <div
          key={`partner-skeleton-${type}`}
          className={`tab-content mw-960px ${type === "brand" ? "mb-0 md:mb-12" : "mb-12"}`}
        >
          <Skeleton.Text className="w-1/2 h-8 mx-auto mb-8" />
          <div
            className={`${
              type === "brand"
                ? "flex gap-[80px] md:gap-[50px] justify-center"
                : "grid grid-cols-1 md:grid-cols-3 gap-[50px]"
            } [@media(max-width:900px)]:gap-[20px] md:px-20 mt-[20px] md:mt-[100px]`}
          >
            {Array.from({ length: type === "brand" ? 5 : 6 }).map((_, index) => (
              <Skeleton
                key={index}
                className={`w-full ${
                  type === "brand" ? "h-[70px] max-w-[70px]" : "aspect-square"
                }`}
                text={type !== "brand"}
                textLines={1}
                textClassName="h-6 w-2/3"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );

  const tabItems = useMemo(
    () => [
      {
        key: "1",
        label: <span className="normal-text">{t("LABEL")}</span>,
        children: isLoading ? (
          renderLabelSkeleton()
        ) : (
          <div className="tab-wrapper">
            {labelData.map((airline, index) => (
            <div key={airline.id} className="tab-content mb-0 md:mb-12">
              {/* Title with lines on both sides */}
              <div className="title-with-lines">
                <span className="inline-block px-4 text-center whitespace-normal md:whitespace-nowrap uppercase tracking-wider post-title-nw title-2">
                  {airline.title}
                </span>
              </div>

              {/* Image */}
              <div className="image-wrapper flex-col gap-[50px]">
                <img
                  src={airline.image}
                  alt={airline.title}
                  className="post-img object-cover"
                />
                <span
                  className=" mx-wrapper text-justify normal-text"
                  dangerouslySetInnerHTML={sanitize(airline.description)}
                />
              </div>

              {/* Description */}
              <div className="my-[50px] mx-wrapper normal-text-nw flex flex-col">
                {/* <a
                  href={airline.url}
                  target="_blank"
                  className="see-more cursor-pointer underline mt-2 hover:underline"
                >
                  Xem Thêm
                </a> */}
                {/* <div className="production">
                  <div className="title title-2">DISCOGRAPHY</div>
                  <div className="product ml-0 mr-0 md:-ml-20 md:-mr-20 align-center max-w-full md:max-w-none">
                    {airline.discography?.length > 0 && (
                      <CCarousel>
                        {airline.discography?.map((value, ind) => (
                          <div key={value.id} className="thumbnail-item">
                            <img
                              src={getYouTubeThumbnail(value)}
                              alt="youtube_thumbnail"
                            />
                          </div>
                        ))}
                      </CCarousel>
                    )}
                  </div>
                </div> */}
              </div>
            </div>
          ))}
        </div>
        ),
      },
      {
        key: "2",
        label: <span className="normal-text">{t("PARTNER")}</span>,
        children: isLoading ? (
          renderPartnerSkeleton()
        ) : (
          <div className="tab-wrapper">
            {partnerTypes.map((type) => (
            <div
              key={type}
              className={`tab-content mw-960px ${type === "brand" ? "mb-0 md:mb-12" : "mb-12"} `}
            >
              {/* Title with lines on both sides */}
              <div className="title-with-lines">
                <span
                  className={`inline-block px-4 text-center uppercase tracking-wider post-title-nw title-2 ${
                    type === "brand"
                      ? "brand-title-nowrap"
                      : "whitespace-normal md:whitespace-nowrap"
                  }`}
                >
                  {t(type)}
                </span>
              </div>
              <div
                className={`${
                  type === "brand"
                    ? "flex gap-[80px] md:gap[50px]"
                    : "grid grid-cols-1 md:grid-cols-3 gap-[50px]"
                } [@media(max-width:900px)]:gap-[20px] md:px-20 mt-[20px] md:mt-[100px]`}
              >
                {partnerData
                  .filter((network) => network.type === type)
                  .map((partner, index) =>
                    type === "brand" ? (
                      <div
                        key={index}
                        className="overflow-hidden flex flex-col justify-between rounded-sm"
                      >
                        <div className="relative flex-1 w-[65%] self-center md:w-full overflow-hidden">
                          <img
                            src={partner.logo}
                            alt={partner.title}
                            className="inset-0 w-full h-full object-contain max-w-[70px]"
                          />
                        </div>
                      </div>
                    ) : (
                      <a
                        key={index}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="partner-section overflow-hidden aspect-square w-[70vw] md:w-[15vw] md:h-[15vw] flex flex-col justify-between relative border border-black rounded-sm overflow-hidden transition-all duration-300 hover:border-teal-500 group transition hover:shadow-lg cursor-pointer"
                        onClick={() => {
                          navigate(partner.id, {
                            state: {
                              title: partner.title,
                              description: partner.description,
                              image: partner.image,
                            },
                          });
                        }}
                      >
                        <div className="relative flex-1 self-center w-[50%] md:w-[90%] overflow-hidden">
                          <img
                            src={partner.logo}
                            alt={partner.title}
                            className="absolute inset-0 w-full h-full object-contain 2xl:p-[65px] md:p-[20px]"
                          />
                        </div>

                        <div className="partner-location title-2 border-t border-black group-hover:border-teal-500 bg-transparent px-3 py-2 flex justify-between items-center text-black transition-all duration-300 group-hover:bg-teal-500 group-hover:text-white">
                          <span className="partner-title uppercase tracking-wide normal-text ">
                            {partner.title}
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-8 h-8 transition-colors duration-300"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </div>
                      </a>
                    ),
                  )}
              </div>
            </div>
          ))}
        </div>
        ),
      },
    ],
    [isLoading, labelData, partnerData, t, navigate],
  );

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get("/api/network/list");
      const networkList = response.data.data;
      const modifiedLabelData = networkList.filter(
        (network) => network.type === "label",
      );
      setLabelData(parseDiscographyData(modifiedLabelData));

      setPartnerData(
        networkList.filter(
          (network) =>
            network.type === "partner" ||
            network.type === "strategic partner" ||
            network.type === "brand",
        ),
      );
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  function parseDiscographyData(labelData) {
    // Use the .map() method to iterate over each item and return a new array.
    // This is a non-destructive way to transform the data.
    const modifiedLabelData = labelData.map((item) => {
      let parsedDiscography = [];

      // Use a try-catch block to gracefully handle potential JSON parsing errors.
      // This is important if the data from the API is not guaranteed to be perfect.
      try {
        // Check if the discography property exists and is a string before parsing.
        if (item.discography) {
          parsedDiscography = JSON.parse(item.discography);
        }
      } catch (error) {
        console.error("Error parsing discography for item:", item.id, error);
        // In case of an error, we can log it and return a default value (e.g., an empty array).
        // This prevents the entire application from crashing.
      }

      // Use the spread syntax (...) to create a shallow copy of the original item
      // and then overwrite the `discography` property with the newly parsed data.
      return {
        ...item,
        discography: parsedDiscography,
      };
    });

    return modifiedLabelData;
  }

  const contentStyle = {
    margin: 0,
    height: "160px",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#364d79",
  };
  const onChange = (currentTab) => {
    setCurrentActiveTab(currentTab);
    scrollToTop();
  };
  return (
    <div className="about-ssg">
      <div className="global-header-block-2">
        <FadeInSection direction="down">
          <div className="network-text normal-text">{t("ABOUT_SSL")}</div>
          <h1 className="network-title global-title-margin title-1">
            {t("SSL_NETWORK")}
          </h1>
        </FadeInSection>
      </div>

      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#00C7B4",
          },
          components: {
            Tabs: {
              inkBarColor: "#00C7B4",
              itemActiveColor: "#00C7B4",
              itemHoverColor: "#000000",
              fontSize: "20px",
              gap: "20px",
            },
          },
        }}
      >
        <Tabs
          activeKey={currentActiveTab}
          items={tabItems}
          className="custom-tabs"
          onChange={onChange}
          tabBarStyle={{
            fontWeight: 500,
            position: "sticky",
            top: 70,
            zIndex: 10,
            padding: "20px 0",
            backgroundColor: "#ffffff",
          }}
        />
      </ConfigProvider>
    </div>
  );
}

export default Network;
